export enum PmStatusEnum {
    OPEN = 'OPEN',
    IN_PROGRESS = 'IN_PROGRESS',
    CLOSE = 'CLOSE',
    PARTIAL_PO ='PARTIAL_PO'
}